const middleware = {}

middleware['check-catalog-route'] = require('../middleware/check-catalog-route.js')
middleware['check-catalog-route'] = middleware['check-catalog-route'].default || middleware['check-catalog-route']

export default middleware
